<div class="modal fade" id="dialogEtiqueta" tabindex="-1" role="dialog" aria-labelledby="Etiqueta" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Etiqueta Adiantamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="form-group col-4">
            <label for="proc_inicio">Processo Nº</label>
            <input type="text" [(ngModel)]="processoInicial" unmask="true" [imask]="imaskConfig" class="form-control" />
          </div>
          <div class="form-group col-4">
            <label for="proc_final">&nbsp;</label>
            <input type="text" [(ngModel)]="processoFinal" unmask="true" [imask]="imaskConfig" class="form-control" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="imprimir()" type="button" class="btn btn-secondary" id="btnImp" data-dismiss="modal">Imprimir</button>
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
